





































import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class AiAdviceListHeader extends Vue {
  private aiAdviceSort (name: string) {
    this.$emit('ai-advice-sort', name)
  }
}
